module.exports = __webpack_public_path__ + "img/Nigeria.bf513833.svg";